/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DataMapper } from './data-mapper';
import { HeadersData, HttpDataMapper } from './http-data-mapper';

export class NoAuthRefreshHttpDataMapper<ObjectView> extends HttpDataMapper<ObjectView> {
  constructor(mapper: DataMapper<ObjectView, any>) {
    super(mapper);
  }

  serializeHeaders(headers: HeadersData, obj: ObjectView, json: any): any {
    headers.set('X-No-Auth-Refresh', 'true');

    return json;
  }
}
